import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import SelectForm from '../forms/select-form';
import { selectValidationSchema } from '../schema/select.js';

export default function SelectNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Select Node Details',
        altText: 'Select Node',
        defaultLabel: data?.command || 'Select Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={SelectForm} schemaResolver={selectValidationSchema} />
    </NodeProvider>
  );
}
